export const formatThousandSeparator = (amount) => {
	return amount.toLocaleString('en-US');
};
